
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, tuple_type, bool_type, lambda_type, unit_type, union_type, list_type, class_type, anonRecord_type, option_type, float64_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, UnassignConsumableWithNotificationDto, ConsumableId, FormState_get_empty, RequestedValue$1, FormState_$reflection, RequestedValue$1_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { Consumable_$reflection } from "../../Shared/Consumable.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { length, ofArray, singleton, append, max, tryPick, empty, head, tail, isEmpty, tryFind, choose, sumBy, map, filter } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { createObj, comparePrimitives, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { unassignWithNotificationCmd, getConsumable } from "../../Requests/Consumable.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { uploadImage } from "../../Requests/Files.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { empty as empty_1, append as append_1, singleton as singleton_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Select } from "../../Components/Select.js";
import { NumberInput } from "../../Components/Input.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ReturnResponse", "OnReturn", "SetComment", "SetQuantity", "SetSelectedStorage", "ConsumableFetched", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Consumables.ReturnConsumableNotificationDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", string_type]], [["Item", option_type(float64_type)]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", string_type]))]], [["Item", Consumable_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(ConsumableId, Consumable, UserId, Comment$, Quantity, SelectedStorage, StorageOptions, SuccessCallback, OnClose, FormState, IsQuantityInvalid, IsStorageInvalid, QuantityInvalidTranslationKey, SenderImageFiles, ImageUploading) {
        super();
        this.ConsumableId = ConsumableId;
        this.Consumable = Consumable;
        this.UserId = UserId;
        this.Comment = Comment$;
        this.Quantity = Quantity;
        this.SelectedStorage = SelectedStorage;
        this.StorageOptions = StorageOptions;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
        this.IsQuantityInvalid = IsQuantityInvalid;
        this.IsStorageInvalid = IsStorageInvalid;
        this.QuantityInvalidTranslationKey = QuantityInvalidTranslationKey;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Consumables.ReturnConsumableNotificationDialog.State", [], State, () => [["ConsumableId", string_type], ["Consumable", RequestedValue$1_$reflection(Consumable_$reflection())], ["UserId", string_type], ["Comment", string_type], ["Quantity", option_type(float64_type)], ["SelectedStorage", option_type(anonRecord_type(["label", string_type], ["value", string_type]))], ["StorageOptions", list_type(anonRecord_type(["label", string_type], ["value", string_type]))], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["IsQuantityInvalid", bool_type], ["IsStorageInvalid", bool_type], ["QuantityInvalidTranslationKey", tuple_type(option_type(string_type), option_type(float64_type))], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function getStockPerUser(consumable) {
    return filter((tupledArg_1) => (tupledArg_1[1] > 0), map((tupledArg) => {
        const events = tupledArg[1];
        return [tupledArg[0], sumBy((event_2) => {
            switch (event_2.tag) {
                case 0:
                    return event_2.fields[0].Quantity;
                case 1:
                    return event_2.fields[0].Quantity;
                default:
                    return 0;
            }
        }, events, {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        }) - sumBy((event_3) => {
            if (event_3.tag === 2) {
                return event_3.fields[0].Quantity;
            }
            else {
                return 0;
            }
        }, events, {
            GetZero: () => 0,
            Add: (x_2, y_2) => (x_2 + y_2),
        })];
    }, List_groupBy((event_1) => {
        switch (event_1.tag) {
            case 2:
                return event_1.fields[0].SenderId;
            case 0:
                return event_1.fields[0].ReceiverId;
            case 1:
                return event_1.fields[0].ReceiverId;
            default:
                return "";
        }
    }, choose((event) => {
        switch (event.tag) {
            case 2:
                return event;
            case 0:
                return event;
            case 1:
                return event;
            default:
                return undefined;
        }
    }, consumable.Events), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })));
}

function userStock(consumable, userId) {
    return map_1((tuple) => tuple[1], tryFind((tupledArg) => (tupledArg[0] === userId), getStockPerUser(consumable)));
}

function init(consumableDetail, userId, successCallback, onClose) {
    const storageOptions = map((sps) => ({
        label: sps.StorageName,
        value: sps.StorageId,
    }), consumableDetail.StockPerStorage);
    return [new State(consumableDetail.Id, new RequestedValue$1(0, []), userId, "", undefined, !isEmpty(storageOptions) ? (isEmpty(tail(storageOptions)) ? head(storageOptions) : undefined) : undefined, storageOptions, successCallback, onClose, FormState_get_empty(), false, false, [undefined, undefined], empty(), false), getConsumable((Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(6, [Item_1])), new ConsumableId(parse(consumableDetail.Id)))];
}

function update(msg, state) {
    let file_1;
    switch (msg.tag) {
        case 5:
            return [new State(state.ConsumableId, new RequestedValue$1(1, [msg.fields[0]]), state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 1: {
            const matchValue = state.SelectedStorage;
            const matchValue_1 = state.Quantity;
            const matchValue_2 = state.Consumable;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    if (matchValue_1 === 0) {
                        const quantity_1 = matchValue_1;
                        return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, ["tool.dialog_assign_quantity_empty_validation", undefined], state.SenderImageFiles, state.ImageUploading), Cmd_none()];
                    }
                    else if (matchValue_2.tag === 1) {
                        const quantity_2 = matchValue_1;
                        const storage = matchValue;
                        const matchValue_4 = userStock(matchValue_2.fields[0], state.UserId);
                        if (matchValue_4 == null) {
                            return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, ["consumable.dialog_unassign_quantity_to_low", undefined], state.SenderImageFiles, state.ImageUploading), Cmd_none()];
                        }
                        else if (matchValue_4 < quantity_2) {
                            const stock_1 = matchValue_4;
                            return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, ["consumable.dialog_unassign_quantity_to_low", stock_1], state.SenderImageFiles, state.ImageUploading), Cmd_none()];
                        }
                        else {
                            const dto = new UnassignConsumableWithNotificationDto(undefined, storage.value, state.Comment, quantity_2, "", "userToStorage", choose((f) => {
                                if (f.tag === 1) {
                                    return f.fields[0].ImageUrl;
                                }
                                else {
                                    return undefined;
                                }
                            }, state.SenderImageFiles));
                            const consumableId = new ConsumableId(parse(state.ConsumableId));
                            return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), false, false, [undefined, undefined], state.SenderImageFiles, state.ImageUploading), unassignWithNotificationCmd(consumableId, dto, (Item_1) => (new Msg(0, [Item_1])), (Item_2) => (new Msg(6, [Item_2])))];
                        }
                    }
                    else {
                        return [state, Cmd_none()];
                    }
                }
                else {
                    return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, ["tool.dialog_assign_quantity_empty_validation", undefined], state.SenderImageFiles, state.ImageUploading), Cmd_none()];
                }
            }
            else {
                return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, true, state.QuantityInvalidTranslationKey, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 2:
            return [new State(state.ConsumableId, state.Consumable, state.UserId, msg.fields[0], state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 3:
            return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, msg.fields[0], state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, [undefined, undefined], state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 4:
            return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, msg.fields[0], state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, false, state.QuantityInvalidTranslationKey, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 6:
            return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, state.SenderImageFiles, false), Cmd_none()];
        case 7: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, newFiles, true), uploadImage((Item_3) => (new Msg(8, [Item_3])), (Item_4) => (new Msg(6, [Item_4])), formData)];
                }
                default:
                    return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 8: {
            const response_1 = msg.fields[0];
            switch (response_1.tag) {
                case 0:
                    return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    })) | 0;
                    return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_1.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.ConsumableId, state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.StorageOptions, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.IsQuantityInvalid, state.IsStorageInvalid, state.QuantityInvalidTranslationKey, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
    }
}

export function ReturnConsumableNotificationDialog(props) {
    let Title;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Consumable, props.UserId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.return_notification_title"), {
        Body: toList(delay(() => {
            let elems_1;
            return (state_1.Consumable.tag === 0) ? singleton_1(createElement(Skeleton, {
                Variant: "normal",
            })) : singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_1 = toList(delay(() => append_1(singleton_1(reactElement("p", {
                children: t("tool.return_notification_description"),
            })), delay(() => append_1((length(state_1.StorageOptions) > 1) ? singleton_1(createElement(Select, {
                ComponentState: componentState,
                IsClearable: false,
                Label: t("tool.switch_storage_target"),
                NoOptionsMessage: "",
                OnChange: (value_3) => {
                    dispatch(new Msg(4, [value_3]));
                },
                Options: state_1.StorageOptions,
                PlaceholderKey: "",
                TestId: "return-consumable-notification-dialog-storage-test-id",
                ValidationMessage: unwrap(state_1.IsStorageInvalid ? "tool.switch_storage_missing_storage_validation" : undefined),
                Value: unwrap(state_1.SelectedStorage),
            })) : empty_1(), delay(() => {
                let matchValue_1, key_2, value_5, arg_1, key_3;
                return append_1(singleton_1(createElement(NumberInput, {
                    ComponentState: componentState,
                    Label: t("general.quantity_3"),
                    OnChange: (value_4) => {
                        dispatch(new Msg(3, [value_4]));
                    },
                    TestId: "return-consumable-notification-dialog-quantity-test-id",
                    ValidationMessage: unwrap((matchValue_1 = state_1.QuantityInvalidTranslationKey, (matchValue_1[0] == null) ? undefined : ((matchValue_1[1] != null) ? ((key_2 = matchValue_1[0], (value_5 = matchValue_1[1], (arg_1 = {
                        quantity: value_5,
                    }, patternInput[1].t(key_2, arg_1))))) : ((key_3 = matchValue_1[0], t(key_3)))))),
                    Value: unwrap(state_1.Quantity),
                })), delay(() => append_1(singleton_1(createElement(TextArea, {
                    ComponentState: componentState,
                    Label: t("general.comment"),
                    OnChange: (value_6) => {
                        dispatch(new Msg(2, [value_6]));
                    },
                    TestId: "return-consumable-notification-dialog-comment-test-id",
                    Value: state_1.Comment,
                })), delay(() => {
                    let elems;
                    return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems = [createElement(TextValue, {
                        FontWeight: "bold",
                        TestId: "",
                        Text: t("assignment_notification.sender_images"),
                    }), createElement(ImageUpload, {
                        ComponentState: state_1.ImageUploading ? "disabled" : componentState,
                        SelectedFiles: state_1.SenderImageFiles,
                        SetSelectedFile: (files) => {
                            dispatch(new Msg(7, [files]));
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                        const matchValue_2 = FormState__getValidation(state_1.FormState, t, "global");
                        if (matchValue_2 == null) {
                            return empty_1();
                        }
                        else {
                            return singleton_1(createElement(ErrorAlert, {
                                Label: matchValue_2,
                            }));
                        }
                    }));
                }))));
            })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-return-consumable-notification-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: state_1.ImageUploading ? "disabled" : componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "save-return-consumable-notification-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

